const QueryTypes: { [key: string]: string } = {
  GET: 'get',
  POST: 'post',
  POST_FEEDBACK: 'post',
  PUT: 'put',
}

export default QueryTypes
